(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 70277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgChevronRight = function SvgChevronRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChevronRight);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjI5Mjg5IDUuMjkyODlDOC42ODM0MiA0LjkwMjM3IDkuMzE2NTggNC45MDIzNyA5LjcwNzExIDUuMjkyODlMMTUuNzA3MSAxMS4yOTI5QzE2LjA5NzYgMTEuNjgzNCAxNi4wOTc2IDEyLjMxNjYgMTUuNzA3MSAxMi43MDcxTDkuNzA3MTEgMTguNzA3MUM5LjMxNjU4IDE5LjA5NzYgOC42ODM0MiAxOS4wOTc2IDguMjkyODkgMTguNzA3MUM3LjkwMjM3IDE4LjMxNjYgNy45MDIzNyAxNy42ODM0IDguMjkyODkgMTcuMjkyOUwxMy41ODU4IDEyTDguMjkyODkgNi43MDcxMUM3LjkwMjM3IDYuMzE2NTggNy45MDIzNyA1LjY4MzQyIDguMjkyODkgNS4yOTI4OVoiIC8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 7556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCircleXFilled = function SvgCircleXFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47718 2 2.00002 6.47715 2.00002 12C2.00002 17.5228 6.47718 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2ZM15.2796 8.72018C15.7066 9.14711 15.7066 9.83931 15.2796 10.2663L13.5459 12L15.2796 13.7337C15.7066 14.1606 15.7066 14.8528 15.2796 15.2798C14.8527 15.7067 14.1605 15.7067 13.7336 15.2798L11.9998 13.546L10.2663 15.2796C9.83934 15.7065 9.14714 15.7065 8.7202 15.2796C8.29327 14.8527 8.29326 14.1605 8.7202 13.7335L10.4538 12L8.7202 10.2664C8.29326 9.83948 8.29326 9.14728 8.7202 8.72034C9.14714 8.29341 9.83934 8.29341 10.2663 8.72034L11.9998 10.4539L13.7336 8.72018C14.1605 8.29324 14.8527 8.29324 15.2796 8.72018Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgCircleXFilled);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyQzYuNDc3MTggMiAyLjAwMDAyIDYuNDc3MTUgMi4wMDAwMiAxMkMyLjAwMDAyIDE3LjUyMjggNi40NzcxOCAyMiAxMiAyMkMxNy41MjI5IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcxNSAxNy41MjI5IDIgMTIgMlpNMTUuMjc5NiA4LjcyMDE4QzE1LjcwNjYgOS4xNDcxMSAxNS43MDY2IDkuODM5MzEgMTUuMjc5NiAxMC4yNjYzTDEzLjU0NTkgMTJMMTUuMjc5NiAxMy43MzM3QzE1LjcwNjYgMTQuMTYwNiAxNS43MDY2IDE0Ljg1MjggMTUuMjc5NiAxNS4yNzk4QzE0Ljg1MjcgMTUuNzA2NyAxNC4xNjA1IDE1LjcwNjcgMTMuNzMzNiAxNS4yNzk4TDExLjk5OTggMTMuNTQ2TDEwLjI2NjMgMTUuMjc5NkM5LjgzOTM0IDE1LjcwNjUgOS4xNDcxNCAxNS43MDY1IDguNzIwMiAxNS4yNzk2QzguMjkzMjcgMTQuODUyNyA4LjI5MzI2IDE0LjE2MDUgOC43MjAyIDEzLjczMzVMMTAuNDUzOCAxMkw4LjcyMDIgMTAuMjY2NEM4LjI5MzI2IDkuODM5NDggOC4yOTMyNiA5LjE0NzI4IDguNzIwMiA4LjcyMDM0QzkuMTQ3MTQgOC4yOTM0MSA5LjgzOTM0IDguMjkzNDEgMTAuMjY2MyA4LjcyMDM0TDExLjk5OTggMTAuNDUzOUwxMy43MzM2IDguNzIwMThDMTQuMTYwNSA4LjI5MzI0IDE0Ljg1MjcgOC4yOTMyNCAxNS4yNzk2IDguNzIwMThaIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 78222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(23560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/mailbox.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgMailbox = function SvgMailbox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 350,
    height: 304,
    viewBox: "0 0 350 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M175.025 304.002C271.48 304.002 349.672 299.437 349.672 293.806C349.672 288.174 271.48 283.609 175.025 283.609C78.5699 283.609 0.377686 288.174 0.377686 293.806C0.377686 299.437 78.5699 304.002 175.025 304.002Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M182.675 99.3359H168.63V289.782H182.675V99.3359Z",
    fill: "#A1E763"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M153.473 53.6468C153.555 49.1813 152.747 44.7442 151.095 40.5946C149.443 36.4451 146.981 32.6664 143.852 29.4793C140.723 26.2921 136.991 23.7605 132.873 22.0323C128.754 20.3042 124.333 19.4141 119.866 19.4141C115.4 19.4141 110.979 20.3042 106.86 22.0323C102.742 23.7605 99.0095 26.2921 95.8807 29.4793C92.7519 32.6664 90.2896 36.4451 88.6377 40.5946C86.9859 44.7442 86.1776 49.1813 86.26 53.6468V99.3337H153.473V53.6468Z",
    fill: "#6D9749"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M79.8908 118.936C75.4 137.495 86.7645 152.537 105.369 152.537C123.974 152.537 142.613 137.495 147.104 118.936L151.778 99.61C151.842 99.3496 151.847 99.0779 151.79 98.8157C151.734 98.5534 151.619 98.3074 151.453 98.0964C151.287 97.8855 151.076 97.7151 150.834 97.5982C150.593 97.4813 150.328 97.421 150.059 97.4219H86.4895C86.0918 97.4238 85.7062 97.5593 85.3946 97.8065C85.083 98.0537 84.8635 98.3983 84.7711 98.7852L79.8908 118.936Z",
    fill: "#6D9749"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M79.2275 118.936C74.5498 137.495 86.3871 152.537 105.766 152.537C125.145 152.537 144.559 137.495 149.237 118.936L154.153 99.61C154.22 99.3496 154.224 99.0779 154.166 98.8157C154.107 98.5534 153.987 98.3074 153.814 98.0964C153.642 97.8855 153.421 97.7151 153.17 97.5982C152.918 97.4813 152.642 97.421 152.363 97.4219H86.1365C85.7222 97.4238 85.3206 97.5593 84.9961 97.8065C84.6715 98.0537 84.4428 98.3983 84.3466 98.7852L79.2275 118.936Z",
    fill: "#A1E763"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M232.566 53.632V99.3305H153.519V53.632C153.516 44.7215 149.975 36.1768 143.674 29.876C137.374 23.5753 128.829 20.0343 119.918 20.0312H199.023C207.933 20.0343 216.478 23.5753 222.779 29.876C229.08 36.1768 232.621 44.7215 232.624 53.632H232.566Z",
    fill: "#A1E763"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M164.483 71.7478V4.15674C164.481 3.55414 164.611 2.95847 164.863 2.4112C165.116 1.86392 165.484 1.37819 165.943 0.987818C166.402 0.597446 166.941 0.311813 167.522 0.150793C168.102 -0.0102272 168.711 -0.0427632 169.306 0.0554532L185.505 2.73618C186.085 2.83153 186.613 3.1307 186.993 3.58C187.373 4.02931 187.58 4.59935 187.578 5.1878V9.38073C187.578 10.0401 187.316 10.6724 186.85 11.1386C186.384 11.6048 185.751 11.8667 185.092 11.8667H169.638V71.7249C169.638 72.4085 169.366 73.0642 168.883 73.5476C168.399 74.031 167.744 74.3025 167.06 74.3025C166.381 74.3026 165.728 74.0341 165.246 73.5557C164.763 73.0772 164.489 72.4275 164.483 71.7478Z",
    fill: "#6D9749"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M119.861 28.9593V62.5486C119.858 63.4238 119.51 64.2624 118.892 64.8823C118.274 65.5022 117.437 65.8534 116.562 65.8594H52.6021C51.7269 65.8534 50.8895 65.5022 50.2717 64.8823C49.6539 64.2624 49.3057 63.4238 49.3027 62.5486V28.9593C49.3057 28.0841 49.6539 27.2454 50.2717 26.6255C50.8895 26.0056 51.7269 25.6545 52.6021 25.6484H116.562C117.437 25.6545 118.274 26.0056 118.892 26.6255C119.51 27.2454 119.858 28.0841 119.861 28.9593Z",
    fill: "#2D71EA"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M118.807 26.5422L92.9849 47.2663C90.5909 49.1841 87.6149 50.2291 84.5475 50.2291C81.48 50.2291 78.5041 49.1841 76.11 47.2663L50.3223 26.5422C50.943 25.9612 51.7634 25.6412 52.6135 25.6486H116.573C117.403 25.6557 118.201 25.9747 118.807 26.5422Z",
    fill: "#2D71EA"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M118.807 26.5422L92.9849 47.2663C90.5909 49.1841 87.6149 50.2291 84.5475 50.2291C81.48 50.2291 78.5041 49.1841 76.11 47.2663L50.3223 26.5422C50.943 25.9612 51.7634 25.6412 52.6135 25.6486H116.573C117.403 25.6557 118.201 25.9747 118.807 26.5422Z",
    fill: "#1D2131"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M70.8517 79.4009V113.002C70.8517 113.878 70.5045 114.718 69.886 115.339C69.2676 115.959 68.4284 116.309 67.5523 116.313H3.62725C2.75208 116.306 1.91464 115.955 1.29687 115.335C0.679092 114.716 0.330878 113.877 0.327881 113.002V79.4009C0.327881 78.5259 0.675495 77.6867 1.29425 77.0679C1.913 76.4492 2.7522 76.1016 3.62725 76.1016H67.5523C68.4274 76.1016 69.2666 76.4492 69.8853 77.0679C70.5041 77.6867 70.8517 78.5259 70.8517 79.4009Z",
    fill: "#2D71EA"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M69.7973 76.984L44.0096 97.7081C41.6183 99.6318 38.6413 100.681 35.5722 100.681C32.5031 100.681 29.5262 99.6318 27.1348 97.7081L1.33563 76.984C1.95746 76.4062 2.77807 76.0902 3.62685 76.1019H67.5519C68.3856 76.0985 69.1889 76.4141 69.7973 76.984Z",
    fill: "#2D71EA"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M69.7973 76.984L44.0096 97.7081C41.6183 99.6318 38.6413 100.681 35.5722 100.681C32.5031 100.681 29.5262 99.6318 27.1348 97.7081L1.33563 76.984C1.95746 76.4062 2.77807 76.0902 3.62685 76.1019H67.5519C68.3856 76.0985 69.1889 76.4141 69.7973 76.984Z",
    fill: "#1D2131"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M153.474 54.2188V94.4297H129.576C128.699 94.4267 127.859 94.0769 127.238 93.4566C126.618 92.8364 126.268 91.996 126.265 91.1189V57.5296C126.271 56.6533 126.622 55.8147 127.242 55.1951C127.861 54.5755 128.7 54.2248 129.576 54.2188H153.474Z",
    fill: "#2D71EA"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M153.473 54.2191V76.1003C153.35 76.0189 153.231 75.931 153.118 75.8368L127.353 55.1127C127.971 54.5276 128.793 54.2069 129.644 54.2191H153.473Z",
    fill: "#2D71EA"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M153.473 54.2191V76.1003C153.35 76.0189 153.231 75.931 153.118 75.8368L127.353 55.1127C127.971 54.5276 128.793 54.2069 129.644 54.2191H153.473Z",
    fill: "#1D2131"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgMailbox);

/* harmony default export */ var mailbox = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUwIiBoZWlnaHQ9IjMwNCIgdmlld0JveD0iMCAwIDM1MCAzMDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNzUuMDI1IDMwNC4wMDJDMjcxLjQ4IDMwNC4wMDIgMzQ5LjY3MiAyOTkuNDM3IDM0OS42NzIgMjkzLjgwNkMzNDkuNjcyIDI4OC4xNzQgMjcxLjQ4IDI4My42MDkgMTc1LjAyNSAyODMuNjA5Qzc4LjU2OTkgMjgzLjYwOSAwLjM3NzY4NiAyODguMTc0IDAuMzc3Njg2IDI5My44MDZDMC4zNzc2ODYgMjk5LjQzNyA3OC41Njk5IDMwNC4wMDIgMTc1LjAyNSAzMDQuMDAyWiIgZmlsbD0iI0Y3RjhGQSIvPgo8cGF0aCBkPSJNMTgyLjY3NSA5OS4zMzU5SDE2OC42M1YyODkuNzgySDE4Mi42NzVWOTkuMzM1OVoiIGZpbGw9IiNBMUU3NjMiLz4KPHBhdGggZD0iTTE1My40NzMgNTMuNjQ2OEMxNTMuNTU1IDQ5LjE4MTMgMTUyLjc0NyA0NC43NDQyIDE1MS4wOTUgNDAuNTk0NkMxNDkuNDQzIDM2LjQ0NTEgMTQ2Ljk4MSAzMi42NjY0IDE0My44NTIgMjkuNDc5M0MxNDAuNzIzIDI2LjI5MjEgMTM2Ljk5MSAyMy43NjA1IDEzMi44NzMgMjIuMDMyM0MxMjguNzU0IDIwLjMwNDIgMTI0LjMzMyAxOS40MTQxIDExOS44NjYgMTkuNDE0MUMxMTUuNCAxOS40MTQxIDExMC45NzkgMjAuMzA0MiAxMDYuODYgMjIuMDMyM0MxMDIuNzQyIDIzLjc2MDUgOTkuMDA5NSAyNi4yOTIxIDk1Ljg4MDcgMjkuNDc5M0M5Mi43NTE5IDMyLjY2NjQgOTAuMjg5NiAzNi40NDUxIDg4LjYzNzcgNDAuNTk0NkM4Ni45ODU5IDQ0Ljc0NDIgODYuMTc3NiA0OS4xODEzIDg2LjI2IDUzLjY0NjhWOTkuMzMzN0gxNTMuNDczVjUzLjY0NjhaIiBmaWxsPSIjNkQ5NzQ5Ii8+CjxwYXRoIGQ9Ik03OS44OTA4IDExOC45MzZDNzUuNCAxMzcuNDk1IDg2Ljc2NDUgMTUyLjUzNyAxMDUuMzY5IDE1Mi41MzdDMTIzLjk3NCAxNTIuNTM3IDE0Mi42MTMgMTM3LjQ5NSAxNDcuMTA0IDExOC45MzZMMTUxLjc3OCA5OS42MUMxNTEuODQyIDk5LjM0OTYgMTUxLjg0NyA5OS4wNzc5IDE1MS43OSA5OC44MTU3QzE1MS43MzQgOTguNTUzNCAxNTEuNjE5IDk4LjMwNzQgMTUxLjQ1MyA5OC4wOTY0QzE1MS4yODcgOTcuODg1NSAxNTEuMDc2IDk3LjcxNTEgMTUwLjgzNCA5Ny41OTgyQzE1MC41OTMgOTcuNDgxMyAxNTAuMzI4IDk3LjQyMSAxNTAuMDU5IDk3LjQyMTlIODYuNDg5NUM4Ni4wOTE4IDk3LjQyMzggODUuNzA2MiA5Ny41NTkzIDg1LjM5NDYgOTcuODA2NUM4NS4wODMgOTguMDUzNyA4NC44NjM1IDk4LjM5ODMgODQuNzcxMSA5OC43ODUyTDc5Ljg5MDggMTE4LjkzNloiIGZpbGw9IiM2RDk3NDkiLz4KPHBhdGggZD0iTTc5LjIyNzUgMTE4LjkzNkM3NC41NDk4IDEzNy40OTUgODYuMzg3MSAxNTIuNTM3IDEwNS43NjYgMTUyLjUzN0MxMjUuMTQ1IDE1Mi41MzcgMTQ0LjU1OSAxMzcuNDk1IDE0OS4yMzcgMTE4LjkzNkwxNTQuMTUzIDk5LjYxQzE1NC4yMiA5OS4zNDk2IDE1NC4yMjQgOTkuMDc3OSAxNTQuMTY2IDk4LjgxNTdDMTU0LjEwNyA5OC41NTM0IDE1My45ODcgOTguMzA3NCAxNTMuODE0IDk4LjA5NjRDMTUzLjY0MiA5Ny44ODU1IDE1My40MjEgOTcuNzE1MSAxNTMuMTcgOTcuNTk4MkMxNTIuOTE4IDk3LjQ4MTMgMTUyLjY0MiA5Ny40MjEgMTUyLjM2MyA5Ny40MjE5SDg2LjEzNjVDODUuNzIyMiA5Ny40MjM4IDg1LjMyMDYgOTcuNTU5MyA4NC45OTYxIDk3LjgwNjVDODQuNjcxNSA5OC4wNTM3IDg0LjQ0MjggOTguMzk4MyA4NC4zNDY2IDk4Ljc4NTJMNzkuMjI3NSAxMTguOTM2WiIgZmlsbD0iI0ExRTc2MyIvPgo8cGF0aCBkPSJNMjMyLjU2NiA1My42MzJWOTkuMzMwNUgxNTMuNTE5VjUzLjYzMkMxNTMuNTE2IDQ0LjcyMTUgMTQ5Ljk3NSAzNi4xNzY4IDE0My42NzQgMjkuODc2QzEzNy4zNzQgMjMuNTc1MyAxMjguODI5IDIwLjAzNDMgMTE5LjkxOCAyMC4wMzEySDE5OS4wMjNDMjA3LjkzMyAyMC4wMzQzIDIxNi40NzggMjMuNTc1MyAyMjIuNzc5IDI5Ljg3NkMyMjkuMDggMzYuMTc2OCAyMzIuNjIxIDQ0LjcyMTUgMjMyLjYyNCA1My42MzJIMjMyLjU2NloiIGZpbGw9IiNBMUU3NjMiLz4KPHBhdGggZD0iTTE2NC40ODMgNzEuNzQ3OFY0LjE1Njc0QzE2NC40ODEgMy41NTQxNCAxNjQuNjExIDIuOTU4NDcgMTY0Ljg2MyAyLjQxMTJDMTY1LjExNiAxLjg2MzkyIDE2NS40ODQgMS4zNzgxOSAxNjUuOTQzIDAuOTg3ODE4QzE2Ni40MDIgMC41OTc0NDYgMTY2Ljk0MSAwLjMxMTgxMyAxNjcuNTIyIDAuMTUwNzkzQzE2OC4xMDIgLTAuMDEwMjI3MiAxNjguNzExIC0wLjA0Mjc2MzIgMTY5LjMwNiAwLjA1NTQ1MzJMMTg1LjUwNSAyLjczNjE4QzE4Ni4wODUgMi44MzE1MyAxODYuNjEzIDMuMTMwNyAxODYuOTkzIDMuNThDMTg3LjM3MyA0LjAyOTMxIDE4Ny41OCA0LjU5OTM1IDE4Ny41NzggNS4xODc4VjkuMzgwNzNDMTg3LjU3OCAxMC4wNDAxIDE4Ny4zMTYgMTAuNjcyNCAxODYuODUgMTEuMTM4NkMxODYuMzg0IDExLjYwNDggMTg1Ljc1MSAxMS44NjY3IDE4NS4wOTIgMTEuODY2N0gxNjkuNjM4VjcxLjcyNDlDMTY5LjYzOCA3Mi40MDg1IDE2OS4zNjYgNzMuMDY0MiAxNjguODgzIDczLjU0NzZDMTY4LjM5OSA3NC4wMzEgMTY3Ljc0NCA3NC4zMDI1IDE2Ny4wNiA3NC4zMDI1QzE2Ni4zODEgNzQuMzAyNiAxNjUuNzI4IDc0LjAzNDEgMTY1LjI0NiA3My41NTU3QzE2NC43NjMgNzMuMDc3MiAxNjQuNDg5IDcyLjQyNzUgMTY0LjQ4MyA3MS43NDc4WiIgZmlsbD0iIzZEOTc0OSIvPgo8cGF0aCBkPSJNMTE5Ljg2MSAyOC45NTkzVjYyLjU0ODZDMTE5Ljg1OCA2My40MjM4IDExOS41MSA2NC4yNjI0IDExOC44OTIgNjQuODgyM0MxMTguMjc0IDY1LjUwMjIgMTE3LjQzNyA2NS44NTM0IDExNi41NjIgNjUuODU5NEg1Mi42MDIxQzUxLjcyNjkgNjUuODUzNCA1MC44ODk1IDY1LjUwMjIgNTAuMjcxNyA2NC44ODIzQzQ5LjY1MzkgNjQuMjYyNCA0OS4zMDU3IDYzLjQyMzggNDkuMzAyNyA2Mi41NDg2VjI4Ljk1OTNDNDkuMzA1NyAyOC4wODQxIDQ5LjY1MzkgMjcuMjQ1NCA1MC4yNzE3IDI2LjYyNTVDNTAuODg5NSAyNi4wMDU2IDUxLjcyNjkgMjUuNjU0NSA1Mi42MDIxIDI1LjY0ODRIMTE2LjU2MkMxMTcuNDM3IDI1LjY1NDUgMTE4LjI3NCAyNi4wMDU2IDExOC44OTIgMjYuNjI1NUMxMTkuNTEgMjcuMjQ1NCAxMTkuODU4IDI4LjA4NDEgMTE5Ljg2MSAyOC45NTkzWiIgZmlsbD0iIzJENzFFQSIvPgo8cGF0aCBkPSJNMTE4LjgwNyAyNi41NDIyTDkyLjk4NDkgNDcuMjY2M0M5MC41OTA5IDQ5LjE4NDEgODcuNjE0OSA1MC4yMjkxIDg0LjU0NzUgNTAuMjI5MUM4MS40OCA1MC4yMjkxIDc4LjUwNDEgNDkuMTg0MSA3Ni4xMSA0Ny4yNjYzTDUwLjMyMjMgMjYuNTQyMkM1MC45NDMgMjUuOTYxMiA1MS43NjM0IDI1LjY0MTIgNTIuNjEzNSAyNS42NDg2SDExNi41NzNDMTE3LjQwMyAyNS42NTU3IDExOC4yMDEgMjUuOTc0NyAxMTguODA3IDI2LjU0MjJaIiBmaWxsPSIjMkQ3MUVBIi8+CjxwYXRoIGQ9Ik0xMTguODA3IDI2LjU0MjJMOTIuOTg0OSA0Ny4yNjYzQzkwLjU5MDkgNDkuMTg0MSA4Ny42MTQ5IDUwLjIyOTEgODQuNTQ3NSA1MC4yMjkxQzgxLjQ4IDUwLjIyOTEgNzguNTA0MSA0OS4xODQxIDc2LjExIDQ3LjI2NjNMNTAuMzIyMyAyNi41NDIyQzUwLjk0MyAyNS45NjEyIDUxLjc2MzQgMjUuNjQxMiA1Mi42MTM1IDI1LjY0ODZIMTE2LjU3M0MxMTcuNDAzIDI1LjY1NTcgMTE4LjIwMSAyNS45NzQ3IDExOC44MDcgMjYuNTQyMloiIGZpbGw9IiMxRDIxMzEiLz4KPHBhdGggZD0iTTcwLjg1MTcgNzkuNDAwOVYxMTMuMDAyQzcwLjg1MTcgMTEzLjg3OCA3MC41MDQ1IDExNC43MTggNjkuODg2IDExNS4zMzlDNjkuMjY3NiAxMTUuOTU5IDY4LjQyODQgMTE2LjMwOSA2Ny41NTIzIDExNi4zMTNIMy42MjcyNUMyLjc1MjA4IDExNi4zMDYgMS45MTQ2NCAxMTUuOTU1IDEuMjk2ODcgMTE1LjMzNUMwLjY3OTA5MiAxMTQuNzE2IDAuMzMwODc4IDExMy44NzcgMC4zMjc4ODEgMTEzLjAwMlY3OS40MDA5QzAuMzI3ODgxIDc4LjUyNTkgMC42NzU0OTUgNzcuNjg2NyAxLjI5NDI1IDc3LjA2NzlDMS45MTMgNzYuNDQ5MiAyLjc1MjIgNzYuMTAxNiAzLjYyNzI1IDc2LjEwMTZINjcuNTUyM0M2OC40Mjc0IDc2LjEwMTYgNjkuMjY2NiA3Ni40NDkyIDY5Ljg4NTMgNzcuMDY3OUM3MC41MDQxIDc3LjY4NjcgNzAuODUxNyA3OC41MjU5IDcwLjg1MTcgNzkuNDAwOVoiIGZpbGw9IiMyRDcxRUEiLz4KPHBhdGggZD0iTTY5Ljc5NzMgNzYuOTg0TDQ0LjAwOTYgOTcuNzA4MUM0MS42MTgzIDk5LjYzMTggMzguNjQxMyAxMDAuNjgxIDM1LjU3MjIgMTAwLjY4MUMzMi41MDMxIDEwMC42ODEgMjkuNTI2MiA5OS42MzE4IDI3LjEzNDggOTcuNzA4MUwxLjMzNTYzIDc2Ljk4NEMxLjk1NzQ2IDc2LjQwNjIgMi43NzgwNyA3Ni4wOTAyIDMuNjI2ODUgNzYuMTAxOUg2Ny41NTE5QzY4LjM4NTYgNzYuMDk4NSA2OS4xODg5IDc2LjQxNDEgNjkuNzk3MyA3Ni45ODRaIiBmaWxsPSIjMkQ3MUVBIi8+CjxwYXRoIGQ9Ik02OS43OTczIDc2Ljk4NEw0NC4wMDk2IDk3LjcwODFDNDEuNjE4MyA5OS42MzE4IDM4LjY0MTMgMTAwLjY4MSAzNS41NzIyIDEwMC42ODFDMzIuNTAzMSAxMDAuNjgxIDI5LjUyNjIgOTkuNjMxOCAyNy4xMzQ4IDk3LjcwODFMMS4zMzU2MyA3Ni45ODRDMS45NTc0NiA3Ni40MDYyIDIuNzc4MDcgNzYuMDkwMiAzLjYyNjg1IDc2LjEwMTlINjcuNTUxOUM2OC4zODU2IDc2LjA5ODUgNjkuMTg4OSA3Ni40MTQxIDY5Ljc5NzMgNzYuOTg0WiIgZmlsbD0iIzFEMjEzMSIvPgo8cGF0aCBkPSJNMTUzLjQ3NCA1NC4yMTg4Vjk0LjQyOTdIMTI5LjU3NkMxMjguNjk5IDk0LjQyNjcgMTI3Ljg1OSA5NC4wNzY5IDEyNy4yMzggOTMuNDU2NkMxMjYuNjE4IDkyLjgzNjQgMTI2LjI2OCA5MS45OTYgMTI2LjI2NSA5MS4xMTg5VjU3LjUyOTZDMTI2LjI3MSA1Ni42NTMzIDEyNi42MjIgNTUuODE0NyAxMjcuMjQyIDU1LjE5NTFDMTI3Ljg2MSA1NC41NzU1IDEyOC43IDU0LjIyNDggMTI5LjU3NiA1NC4yMTg4SDE1My40NzRaIiBmaWxsPSIjMkQ3MUVBIi8+CjxwYXRoIGQ9Ik0xNTMuNDczIDU0LjIxOTFWNzYuMTAwM0MxNTMuMzUgNzYuMDE4OSAxNTMuMjMxIDc1LjkzMSAxNTMuMTE4IDc1LjgzNjhMMTI3LjM1MyA1NS4xMTI3QzEyNy45NzEgNTQuNTI3NiAxMjguNzkzIDU0LjIwNjkgMTI5LjY0NCA1NC4yMTkxSDE1My40NzNaIiBmaWxsPSIjMkQ3MUVBIi8+CjxwYXRoIGQ9Ik0xNTMuNDczIDU0LjIxOTFWNzYuMTAwM0MxNTMuMzUgNzYuMDE4OSAxNTMuMjMxIDc1LjkzMSAxNTMuMTE4IDc1LjgzNjhMMTI3LjM1MyA1NS4xMTI3QzEyNy45NzEgNTQuNTI3NiAxMjguNzkzIDU0LjIwNjkgMTI5LjY0NCA1NC4yMTkxSDE1My40NzNaIiBmaWxsPSIjMUQyMTMxIi8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/toast/toast.tsx + 2 modules
var toast = __webpack_require__(7415);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/utils/src/hooks/use-event-tracking.tsx + 4 modules
var use_event_tracking = __webpack_require__(43287);
// EXTERNAL MODULE: ../../libs/utils/src/lib/amplitude/index.tsx
var amplitude = __webpack_require__(67071);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/alert-circle.svg
var alert_circle = __webpack_require__(37413);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/icon-button/icon-button.tsx
var icon_button = __webpack_require__(48031);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/input/input.module.scss
var input_module = __webpack_require__(2160);
var input_module_default = /*#__PURE__*/__webpack_require__.n(input_module);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/components/input/input.tsx








const INPUT_PADDING = 12;
const MINIMUM_FIXED_WIDTH = 32;
const Input = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { label , id , placeholder , optionalText , startAdornment , prefix , suffix , actionButton , size ="medium" , helperText ="" , error , disabled =false , className ="" , inputClassName ="" , actionButtonClassName ="" , startAdornmentClassName ="" , hiddenLabel =false , hasError , trackingIdentifier , ...restProps } = param;
    const prefixRef = (0,react.useRef)(null);
    const suffixRef = (0,react.useRef)(null);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,use_event_tracking/* useInputTypingEventTracking */.a)(innerRef, amplitude/* AmplitudeContext */.Lq, "input_change", {
        id: trackingIdentifier,
        label
    });
    const supportText = error || helperText;
    const buttonTrackingIdentifier = trackingIdentifier && "".concat(trackingIdentifier, " input button");
    const inputClasses = classnames_default()(inputClassName, (input_module_default()).input, {
        [(input_module_default())["button-input-label"]]: actionButton && actionButton.label,
        [(input_module_default())["button-input-icon"]]: actionButton && actionButton.icon,
        [(input_module_default())["input-optional-icon"]]: startAdornment
    });
    const hasActionButton = actionButton && (actionButton.label || actionButton.icon);
    const hasActionIconButton = actionButton && actionButton.isIconButton;
    const renderActionButton = (0,react.useMemo)(()=>{
        if (hasActionIconButton) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.ZP, {
                disabled: disabled,
                className: classnames_default()((input_module_default())["optional-button"], actionButtonClassName),
                onClick: actionButton.onClick,
                type: "button",
                size: size,
                variant: actionButton.variant,
                icon: actionButton.icon,
                label: actionButton.label,
                trackingIdentifier: buttonTrackingIdentifier,
                ...actionButton.data
            });
        }
        if (hasActionButton) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.ZP, {
                disabled: disabled,
                className: classnames_default()((input_module_default())["optional-button"], actionButtonClassName),
                onClick: actionButton.onClick,
                type: "button",
                size: size,
                variant: actionButton.variant,
                startAdornment: actionButton.icon,
                trackingIdentifier: buttonTrackingIdentifier,
                ...actionButton.data,
                children: actionButton.label
            });
        }
        if (suffix) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (input_module_default()).suffix,
                ref: suffixRef,
                children: suffix
            });
        }
        return null;
    }, [
        hasActionIconButton,
        hasActionButton,
        suffix,
        disabled,
        actionButtonClassName,
        actionButton,
        size,
        buttonTrackingIdentifier
    ]);
    const renderOptional = (0,react.useMemo)(()=>{
        return optionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: classnames_default()((input_module_default()).optional, (input_module_default())["optional-text"]),
            children: optionalText
        });
    }, [
        optionalText
    ]);
    const renderLeftAdornment = (0,react.useMemo)(()=>{
        if (prefix) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (input_module_default()).prefix,
                ref: prefixRef,
                children: prefix
            });
        }
        const StartAdornment = startAdornment;
        return startAdornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(StartAdornment, {
            className: classnames_default()((input_module_default())["optional-icon"], startAdornmentClassName)
        });
    }, [
        prefix,
        startAdornment,
        startAdornmentClassName
    ]);
    const renderStyle = ()=>{
        const style = {};
        if (prefix) {
            const prefixElement = prefixRef === null || prefixRef === void 0 ? void 0 : prefixRef.current;
            const prefixWidth = prefixElement ? (prefixElement === null || prefixElement === void 0 ? void 0 : prefixElement.offsetLeft) + INPUT_PADDING + (prefixElement === null || prefixElement === void 0 ? void 0 : prefixElement.offsetWidth) : MINIMUM_FIXED_WIDTH;
            style.paddingLeft = prefixWidth;
        }
        if (suffix) {
            const suffixElement = suffixRef === null || suffixRef === void 0 ? void 0 : suffixRef.current;
            const suffixWidth = suffixElement ? 2 * INPUT_PADDING + (suffixElement === null || suffixElement === void 0 ? void 0 : suffixElement.offsetWidth) : MINIMUM_FIXED_WIDTH;
            style.paddingRight = suffixWidth;
        }
        return style;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((input_module_default())["input-wrapper"], {
            [(input_module_default())["disabled-input"]]: disabled,
            [(input_module_default())["has-label"]]: label && !hiddenLabel || optionalText,
            [(input_module_default())["has-support-text"]]: supportText
        }, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                className: classnames_default()((input_module_default()).label, {
                    [(input_module_default())["visually-hidden"]]: hiddenLabel
                }),
                children: label
            }),
            renderOptional,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((input_module_default())["input-container"], (input_module_default())[size], {
                    [(input_module_default())["input-error"]]: hasError || !!error
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        disabled: disabled,
                        "aria-describedby": supportText ? "".concat(id, "helperText") : "",
                        id: id,
                        className: inputClasses,
                        placeholder: placeholder,
                        ref: innerRef,
                        style: renderStyle(),
                        ...restProps
                    }),
                    renderLeftAdornment,
                    renderActionButton
                ]
            }),
            (!!helperText || !!error) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                id: "".concat(id, "helperText"),
                className: classnames_default()((input_module_default())["helper-text"], {
                    [(input_module_default())["helper-text-error"]]: !!error
                }),
                children: [
                    !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_circle/* ReactComponent */.r, {
                        className: (input_module_default()).icon
                    }),
                    " ",
                    supportText
                ]
            })
        ]
    });
});
/* harmony default export */ var input = ((/* unused pure expression or super */ null && (Input)));

// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-a7690a33.esm.js + 2 modules
var index_a7690a33_esm = __webpack_require__(4441);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(94634);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/dropdown-down.svg
var dropdown_down_path;
var dropdown_down_excluded = ["title", "titleId"];
function dropdown_down_extends() { dropdown_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dropdown_down_extends.apply(this, arguments); }
function dropdown_down_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = dropdown_down_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function dropdown_down_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgDropdownDown = function SvgDropdownDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = dropdown_down_objectWithoutProperties(_ref, dropdown_down_excluded);
  return /*#__PURE__*/react.createElement("svg", dropdown_down_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, dropdown_down_path || (dropdown_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.3051 14.7112L7.28981 10.683C6.67071 10.062 7.10918 9 7.98471 9H16.0153C16.8908 9 17.3293 10.062 16.7102 10.683L12.6949 14.7112C12.3111 15.0963 11.6889 15.0963 11.3051 14.7112Z"
  })));
};
var dropdown_down_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgDropdownDown);

/* harmony default export */ var dropdown_down = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMwNTEgMTQuNzExMkw3LjI4OTgxIDEwLjY4M0M2LjY3MDcxIDEwLjA2MiA3LjEwOTE4IDkgNy45ODQ3MSA5SDE2LjAxNTNDMTYuODkwOCA5IDE3LjMyOTMgMTAuMDYyIDE2LjcxMDIgMTAuNjgzTDEyLjY5NDkgMTQuNzExMkMxMi4zMTExIDE1LjA5NjMgMTEuNjg4OSAxNS4wOTYzIDExLjMwNTEgMTQuNzExMloiIC8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/circle-x-filled.svg
var circle_x_filled = __webpack_require__(7556);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/check.svg
var check_path;
var check_excluded = ["title", "titleId"];
function check_extends() { check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_extends.apply(this, arguments); }
function check_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = check_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function check_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = check_objectWithoutProperties(_ref, check_excluded);
  return /*#__PURE__*/react.createElement("svg", check_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, check_path || (check_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 6.29289C21.0976 6.68342 21.0976 7.31658 20.7071 7.70711L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L10 15.5858L19.2929 6.29289C19.6834 5.90237 20.3166 5.90237 20.7071 6.29289Z"
  })));
};
var check_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCheck);

/* harmony default export */ var check = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC43MDcxIDYuMjkyODlDMjEuMDk3NiA2LjY4MzQyIDIxLjA5NzYgNy4zMTY1OCAyMC43MDcxIDcuNzA3MTFMMTAuNzA3MSAxNy43MDcxQzEwLjMxNjYgMTguMDk3NiA5LjY4MzQyIDE4LjA5NzYgOS4yOTI4OSAxNy43MDcxTDQuMjkyODkgMTIuNzA3MUMzLjkwMjM3IDEyLjMxNjYgMy45MDIzNyAxMS42ODM0IDQuMjkyODkgMTEuMjkyOUM0LjY4MzQyIDEwLjkwMjQgNS4zMTY1OCAxMC45MDI0IDUuNzA3MTEgMTEuMjkyOUwxMCAxNS41ODU4TDE5LjI5MjkgNi4yOTI4OUMxOS42ODM0IDUuOTAyMzcgMjAuMzE2NiA1LjkwMjM3IDIwLjcwNzEgNi4yOTI4OVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/select/index.module.scss
var index_module = __webpack_require__(23601);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/components/select/index.tsx






const Select = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { value , onChange , startIcon , className ="" , id , isOptional =false , label , labelClassName ="" , placeholder , options , size ="small" , helperText ="" , error ="" , isDisabled , isLoading , isClearable , isSearchable =false , hiddenLabel , variant ="default" , type ="default" , onInputChange , ...rest } = param;
    const selectId = "select-".concat(id);
    const DropdownIndicator = (0,react.useCallback)((props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_a7690a33_esm.c.DropdownIndicator, {
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_down_ForwardRef, {
                className: (index_module_default())["indicator-icon"]
            })
        });
    }, []);
    const ClearIndicator = (0,react.useCallback)((props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_a7690a33_esm.c.ClearIndicator, {
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_x_filled/* ReactComponent */.r, {
                className: (index_module_default())["clear-icon"]
            })
        });
    }, []);
    const ValueContainer = (0,react.useCallback)((param)=>{
        let { children , ...props } = param;
        const StartIcon = startIcon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_a7690a33_esm.c.ValueContainer, {
            ...props,
            className: classnames_default()({
                [(index_module_default())["select-button"]]: type === "button"
            }),
            children: [
                startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StartIcon, {
                    className: (index_module_default())["start-icon"]
                }),
                children
            ]
        });
    }, [
        startIcon,
        type
    ]);
    const Option = (0,react.useCallback)((props)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_a7690a33_esm.c.Option, {
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default())["option-label"],
                            children: props.data.label
                        }),
                        props.data.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default())["option-description"],
                            children: props.data.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(check_ForwardRef, {
                    className: (index_module_default())["option-end-icon"]
                })
            ]
        });
    }, []);
    const renderHelperText = (0,react.useMemo)(()=>{
        if (!helperText && !error) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["helper-text-wrapper"],
            children: [
                !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_circle/* ReactComponent */.r, {
                    className: (index_module_default())["helper-icon"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()((index_module_default())["helper-text"], {
                        [(index_module_default())["helper-text-error"]]: !!error
                    }),
                    children: error || helperText
                })
            ]
        });
    }, [
        error,
        helperText
    ]);
    const NoFilterOption = (0,react.useCallback)(()=>true, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: classnames_default()((index_module_default()).wrapper, (index_module_default())[size], className, {
            [(index_module_default()).error]: !!error,
            [(index_module_default()).disabled]: isDisabled,
            [(index_module_default())["with-start-icon"]]: !!startIcon,
            [(index_module_default())["select-button"]]: type === "button"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: selectId,
                className: classnames_default()((index_module_default()).label, labelClassName, {
                    [(index_module_default())["visually-hidden"]]: hiddenLabel
                }),
                children: label
            }),
            isOptional && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).optional,
                children: "Optional"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                ...rest,
                inputId: selectId,
                instanceId: id,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                noOptionsMessage: ()=>"No results",
                className: classnames_default()((index_module_default())["select-wrapper"], (index_module_default())[variant], {
                    [(index_module_default())["select-button"]]: type === "button",
                    [(index_module_default()).applied]: value !== null
                }),
                classNamePrefix: "select",
                components: {
                    ClearIndicator,
                    DropdownIndicator,
                    ValueContainer,
                    Option
                },
                isDisabled: isDisabled,
                isLoading: isLoading,
                isClearable: isClearable,
                isSearchable: isSearchable,
                onInputChange: onInputChange,
                options: options,
                filterOption: onInputChange ? NoFilterOption : undefined
            }),
            renderHelperText
        ]
    });
});
/* harmony default export */ var components_select = ((/* unused pure expression or super */ null && (Select)));

// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/textarea/textarea.module.scss
var textarea_module = __webpack_require__(45448);
var textarea_module_default = /*#__PURE__*/__webpack_require__.n(textarea_module);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/components/textarea/textarea.tsx






// TODO: This is a generic textarea, made based on the current task.
// Update if there is a component in figma
const Textarea = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { maxLength , id , rows , className , label , hiddenLabel , helperText , optionalText , name , error ="" , value , onChange , trackingIdentifier , ...rest } = param;
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,use_event_tracking/* useInputTypingEventTracking */.a)(innerRef, amplitude/* AmplitudeContext */.Lq, "input_change", {
        id: trackingIdentifier,
        label
    });
    const renderErrorText = (0,react.useMemo)(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (textarea_module_default())["error-wrapper"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_circle/* ReactComponent */.r, {
                    className: (textarea_module_default())["error-icon"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (textarea_module_default())["error-text"],
                    children: error
                })
            ]
        }), [
        error
    ]);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((textarea_module_default())["textarea-wrapper"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (textarea_module_default())["label-content"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: classnames_default()((textarea_module_default()).label, {
                            [(textarea_module_default())["visually-hidden"]]: hiddenLabel
                        }),
                        htmlFor: id,
                        children: label
                    }),
                    optionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()((textarea_module_default()).optional, (textarea_module_default())["optional-text"]),
                        children: optionalText
                    })
                ]
            }),
            !!helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: "".concat(id, "helperText"),
                className: classnames_default()((textarea_module_default())["helper-text"]),
                children: helperText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                name: name,
                className: classnames_default()((textarea_module_default()).textarea, {
                    [(textarea_module_default()).error]: error
                }),
                maxLength: maxLength,
                id: id,
                rows: rows,
                ref: innerRef,
                onChange: onChange,
                value: value,
                ...rest
            }),
            maxLength && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (textarea_module_default())["input-counter"],
                children: [
                    (ref1 = value === null || value === void 0 ? void 0 : value.length) !== null && ref1 !== void 0 ? ref1 : 0,
                    "/",
                    maxLength
                ]
            }),
            error && renderErrorText
        ]
    });
});
/* harmony default export */ var textarea_textarea = ((/* unused pure expression or super */ null && (Textarea)));

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/utils/src/lib/constants.ts
var lib_constants = __webpack_require__(19767);
// EXTERNAL MODULE: ../../libs/utils/src/lib/validations.ts + 1 modules
var validations = __webpack_require__(11821);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/contact-us/form/index.module.scss
var form_index_module = __webpack_require__(67720);
var form_index_module_default = /*#__PURE__*/__webpack_require__.n(form_index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/contact-us/form/index.tsx







const TOPIC_OPTIONS = [
    {
        value: "HIRE_TALENT",
        label: "Hire talent"
    },
    {
        value: "APPLY_FOR_JOBS",
        label: "Apply for jobs"
    },
    {
        value: "MEDIA_PRESS",
        label: "Media & press"
    },
    {
        value: "OTHER",
        label: "Other"
    }
];
const fetcher = async (body)=>{
    const apiUrl = "https://platform-api.olby.com/website" || 0;
    const url = "".concat(apiUrl, "/contact-us/");
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            Accept: "application/json"
        },
        body: JSON.stringify(body)
    });
    return res;
};
const ContactUsForm = (param)=>{
    let { className  } = param;
    var ref, ref1, ref2;
    const { register , control , handleSubmit , reset , formState: { errors  }  } = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit"
    });
    const { isLoading , mutate  } = (0,index_production.useMutation)(fetcher, {
        onSuccess: ()=>{
            (0,toast/* toast */.A)({
                title: "Your message was successfully sent!"
            });
            reset();
        }
    });
    const onSubmit = handleSubmit((formData)=>{
        const payload = {
            ...formData,
            topic: formData.topic.label
        };
        mutate(payload);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: classnames_default()((form_index_module_default()).wrapper, className),
        onSubmit: onSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                label: "Your name",
                id: "name",
                placeholder: "Full name",
                error: (ref = errors.name) === null || ref === void 0 ? void 0 : ref.message,
                ...register("name", {
                    required: lib_constants/* REQUIRED_FIELD */.Ce
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                label: "Your email",
                placeholder: "Email",
                id: "email",
                type: "email",
                error: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message,
                ...register("email", {
                    required: lib_constants/* REQUIRED_FIELD */.Ce,
                    validate: validations/* EMAIL_VALIDATION */.QT
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: "topic",
                control: control,
                rules: {
                    required: lib_constants/* REQUIRED_FIELD */.Ce
                },
                render: (param)=>{
                    let { field: { onChange , value  }  } = param;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select, {
                        "aria-labelledby": "topic",
                        id: "topic",
                        label: "Topic",
                        value: value,
                        onChange: onChange,
                        options: TOPIC_OPTIONS,
                        placeholder: "Select...",
                        error: (ref = errors.topic) === null || ref === void 0 ? void 0 : ref.message
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, {
                id: "content",
                label: "How can we help?",
                rows: 8,
                error: (ref2 = errors.content) === null || ref2 === void 0 ? void 0 : ref2.message,
                ...register("content", {
                    required: lib_constants/* REQUIRED_FIELD */.Ce
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                type: "submit",
                variant: "primary",
                size: "large",
                className: (form_index_module_default()).button,
                isLoading: isLoading,
                children: "Send message"
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/contact-us/card/index.tsx
var card = __webpack_require__(25175);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/talent/newsletter/index.tsx
var newsletter = __webpack_require__(81606);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ./pages/contact-us/index.module.scss
var contact_us_index_module = __webpack_require__(57808);
var contact_us_index_module_default = /*#__PURE__*/__webpack_require__.n(contact_us_index_module);
;// CONCATENATED MODULE: ./pages/contact-us/index.tsx




const SEO = {
    title: "Contact us // Olby",
    description: "Have any questions? We’ll be happy to help you."
};
const ContactUs = ()=>{
    const sectionRef = (0,react.useRef)(null);
    const newsletterRef = (0,react.useRef)(null);
    (0,use_update_header/* useUpdateHeader */.G)(sectionRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_update_header/* useUpdateHeader */.G)(newsletterRef, constants/* HEADER_THEMES.EXT_DEEP_BLUE */._.EXT_DEEP_BLUE);
    (0,use_clean_header/* useCleanHeader */._)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (contact_us_index_module_default()).wrapper,
                ref: sectionRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                        seo: SEO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (contact_us_index_module_default())["content-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (contact_us_index_module_default()).title,
                                children: "Contact us"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (contact_us_index_module_default()).description,
                                children: "We’ll be happy to help you."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (contact_us_index_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (contact_us_index_module_default()).picture,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                                            className: (contact_us_index_module_default()).icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsForm, {
                                        className: (contact_us_index_module_default()).form
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* GeneralInformationCard */.e, {
                                        className: (contact_us_index_module_default()).card
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter/* TalentNewsletterSections */.w, {
                ref: newsletterRef
            })
        ]
    });
};
/* harmony default export */ var contact_us = (ContactUs);
ContactUs.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND,
        children: page
    });
};


/***/ }),

/***/ 25175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ GeneralInformationCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(946);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70277);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36257);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);





const GeneralInformationCard = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Looking for general information?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                children: "We have FAQs to help you."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                href: "/faq/talent",
                endIcon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .ReactComponent */ .r,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["talent-link"]),
                prefetch: false,
                children: "Talent FAQ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                href: "/faq/companies",
                endIcon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .ReactComponent */ .r,
                prefetch: false,
                children: "Companies FAQ"
            })
        ]
    });
};


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 81606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ TalentNewsletterSections; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _newsletter_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45169);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86829);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);




const TalentNewsletterSections = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["section-wrapper"]),
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: [
                        "Join our ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().highlight),
                            children: "newsletter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                    children: "International career content straight to your inbox"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_newsletter_forms__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().form)
                })
            ]
        })
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TalentNewsletterSections)));


/***/ }),

/***/ 57808:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contact-us_wrapper__cvQXN","content-wrapper":"contact-us_content-wrapper__r70SM","title":"contact-us_title__aYYkN","theme--light":"contact-us_theme--light__xfaR_","theme--dark":"contact-us_theme--dark__fcYiC","description":"contact-us_description__nkV9C","content":"contact-us_content__969ie","picture":"contact-us_picture___VDh6","icon":"contact-us_icon__wVior","form":"contact-us_form__KOm_C","card":"contact-us_card__wauhS","fade-in-up":"contact-us_fade-in-up__GS21U","fade-in-opacity":"contact-us_fade-in-opacity__EVsDq","fade-in-up-opacity":"contact-us_fade-in-up-opacity__S2t2y","fade-out-opacity":"contact-us_fade-out-opacity__tdPvw","fade-out-left":"contact-us_fade-out-left__tgQYu"};

/***/ }),

/***/ 2160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"input_input-wrapper__VU_Ox","has-label":"input_has-label__FUqYj","has-support-text":"input_has-support-text___c2fz","label":"input_label__RbFt5","visually-hidden":"input_visually-hidden__JbjLc","theme--light":"input_theme--light__eupM8","theme--dark":"input_theme--dark__3J8To","optional":"input_optional__MepFI","optional-text":"input_optional-text__nePIb","input-container":"input_input-container__D7yDY","input":"input_input__JtF14","optional-button":"input_optional-button__FUQMy","optional-icon":"input_optional-icon__h_X4v","prefix":"input_prefix__h0MA_","suffix":"input_suffix__obJei","small":"input_small__4IaPP","button-input-icon":"input_button-input-icon__pKVTD","button-input-label":"input_button-input-label__LeibW","input-optional-icon":"input_input-optional-icon__gXVXs","medium":"input_medium__3GK_q","input-error":"input_input-error__dWXVD","helper-text":"input_helper-text__qMER_","helper-text-error":"input_helper-text-error__stDNM","icon":"input_icon__FrLK3","disabled-input":"input_disabled-input__n9TsL","fade-in-up":"input_fade-in-up__cgmoX","fade-in-opacity":"input_fade-in-opacity__r07m2","fade-in-up-opacity":"input_fade-in-up-opacity__RIQY7","fade-out-opacity":"input_fade-out-opacity__DZEXp","fade-out-left":"input_fade-out-left__84fvS"};

/***/ }),

/***/ 23601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select_wrapper__wgIu5","label":"select_label__V7oxC","theme--light":"select_theme--light__zUYN9","theme--dark":"select_theme--dark__M_vuP","visually-hidden":"select_visually-hidden__cdGPr","optional":"select_optional___LZd3","select-wrapper":"select_select-wrapper__SfMiu","helper-text-wrapper":"select_helper-text-wrapper__3xoWk","helper-icon":"select_helper-icon__l3BvH","helper-text-error":"select_helper-text-error__UeLo7","with-start-icon":"select_with-start-icon__kr_3a","start-icon":"select_start-icon__IwkpD","small":"select_small__i1S5t","indicator-icon":"select_indicator-icon__ODxWq","clear-icon":"select_clear-icon__jxc1u","medium":"select_medium__szxTD","select-button":"select_select-button__6WqHf","error":"select_error__qU1J9","disabled":"select_disabled__7Ojuo","option-label":"select_option-label__HTJCK","option-description":"select_option-description___B5wg","option-end-icon":"select_option-end-icon__39bVM","default":"select_default__a5P22","ghost":"select_ghost__e3gVj","applied":"select_applied__djhy6","fade-in-up":"select_fade-in-up__mgqEf","fade-in-opacity":"select_fade-in-opacity__UXNHi","fade-in-up-opacity":"select_fade-in-up-opacity__yfnpN","fade-out-opacity":"select_fade-out-opacity__ITm_K","fade-out-left":"select_fade-out-left__fStis"};

/***/ }),

/***/ 45448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textarea-wrapper":"textarea_textarea-wrapper__2ynvU","label-content":"textarea_label-content__eLhZP","label":"textarea_label__cFYgd","visually-hidden":"textarea_visually-hidden__zDW4o","theme--light":"textarea_theme--light__cDMLn","theme--dark":"textarea_theme--dark__nKFzf","optional":"textarea_optional__8upo4","optional-text":"textarea_optional-text__1FBp_","helper-text":"textarea_helper-text__hKshl","textarea":"textarea_textarea__eCwYw","error":"textarea_error__qfYUG","input-counter":"textarea_input-counter__WrJn0","error-wrapper":"textarea_error-wrapper__AiXXs","error-icon":"textarea_error-icon__lc2MD","fade-in-up":"textarea_fade-in-up__9BJAz","fade-in-opacity":"textarea_fade-in-opacity__SkZVL","fade-in-up-opacity":"textarea_fade-in-up-opacity__QK_Eo","fade-out-opacity":"textarea_fade-out-opacity__7efil","fade-out-left":"textarea_fade-out-left__O2H5K"};

/***/ }),

/***/ 36257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__g1LzQ","theme--light":"card_theme--light__AkvC6","theme--dark":"card_theme--dark__fFTuN","title":"card_title__UBQcT","description":"card_description__VBl68","talent-link":"card_talent-link__ikacG","fade-in-up":"card_fade-in-up__z7JnV","fade-in-opacity":"card_fade-in-opacity__gc7oY","fade-in-up-opacity":"card_fade-in-up-opacity__2RsMx","fade-out-opacity":"card_fade-out-opacity__UkOqK","fade-out-left":"card_fade-out-left__OByoV"};

/***/ }),

/***/ 67720:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form_wrapper__dwJGj","theme--light":"form_theme--light__sIUIc","theme--dark":"form_theme--dark__PAQkR","button":"form_button___1_83","fade-in-up":"form_fade-in-up__7phfD","fade-in-opacity":"form_fade-in-opacity__0nX7c","fade-in-up-opacity":"form_fade-in-up-opacity__CYWQB","fade-out-opacity":"form_fade-out-opacity__ud83n","fade-out-left":"form_fade-out-left__saK0M"};

/***/ }),

/***/ 86829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"newsletter_section-wrapper__6Wcri","theme--light":"newsletter_theme--light__bDCNk","theme--dark":"newsletter_theme--dark__78dKy","content":"newsletter_content__JeUPp","title":"newsletter_title__XfOmS","highlight":"newsletter_highlight__s307c","description":"newsletter_description__7LvNe","form":"newsletter_form__qd8ZV","fade-in-up":"newsletter_fade-in-up__3PcUI","fade-in-opacity":"newsletter_fade-in-opacity__k8xlF","fade-in-up-opacity":"newsletter_fade-in-up-opacity__0BfOD","fade-out-opacity":"newsletter_fade-out-opacity__8ULql","fade-out-left":"newsletter_fade-out-left__4dfDv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,955,474,634,559,169,774,888,179], function() { return __webpack_exec__(78222); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);